import React from 'react'

import "./Footer.css"
const Footer = () => {
  return (
    <div className='footer'>
  
        <p className='owner'>Created By Deepanshu Mehra</p>
     
      
      
    </div>
  )
}

export default Footer
